type PresetTabLabelProps = {
  label: string;
  active: boolean;
};

export function PresetTabLabel(props: PresetTabLabelProps) {
  return (
    <span className="grid min-w-0 text-left">
      {/* Reserve the selected label width without duplicating accessible text. */}
      <span
        aria-hidden
        data-label={props.label}
        className="invisible col-start-1 row-start-1 overflow-hidden font-semibold whitespace-nowrap before:content-[attr(data-label)]"
      />
      <span
        className={`col-start-1 row-start-1 truncate ${props.active ? 'font-semibold' : 'font-medium'}`}
      >
        {props.label}
      </span>
    </span>
  );
}
